<flx-layout
  layoutVersion="V2"
  [showLanguageSelector]="true"
  [showScreenMaximizationButton]="true"
  [hideMenuBarsWhenScreenIsMaximized]="true"
  [showUserMenu]="true"
  [showNotificationCenter]="true"
>
  <ng-template flxLayout="2ndTopBarContent">
  </ng-template>
  <ng-template flxLayout="3rdTopBar">
  </ng-template>
  
  <router-outlet></router-outlet>
</flx-layout>